var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"scrollable":""},model:{value:(_vm.LOInfoBottomSheetIsOpen),callback:function ($$v) {_vm.LOInfoBottomSheetIsOpen=$$v},expression:"LOInfoBottomSheetIsOpen"}},[_c('v-card',[_c('v-card-title',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.description)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }